module.exports = __webpack_public_path__ + "img/01-@1x.78e3407e.png";